import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { Select } from '@cinesend/ui-kit'
import useStore from '../../hooks/use_store'

const Details = () => {
  const { userID } = useParams()
  const queryKey = ['users/', userID]
  const { data: user, isLoading } = useQuery(queryKey)
  const { data: roles } = useQuery(['roles'])
  const { data: organizations } = useQuery(['organizations'])
  const { updateModel } = useStore()
  const queryClient = useQueryClient()

  const update = (value, isLocal) => {
    if (isLocal) {
      queryClient.setQueryData(queryKey, () => ({
        ...user,
        ...value,
      }))
    } else {
      updateModel.mutate({
        endpoint: 'users',
        id: userID,
        data: value,
      })
    }
  }

  return (
    <div className='flex flex-col space-y-4'>
      <Select
        fullWidth
        label='Role'
        value={user?.role_id ? String(user.role_id) : null}
        disabled={isLoading}
        options={roles?.map((opt) => ({ value: String(opt.id), label: opt.label })) ?? []}
        onValueChange={(id) => update({ role_id: Number(id) }, false)}
      />
      <Select
        fullWidth
        label='Organization'
        value={user?.organization_id ? String(user.organization_id) : null}
        disabled={isLoading}
        options={organizations?.map((opt) => ({ value: String(opt.id), label: opt.name })) ?? []}
        onValueChange={(id) => update({ organization_id: Number(id) }, false)}
      />
    </div>
  )
}

export default Details
